import { ActionTypes } from "../actions";
function getInitialState() {
  return false;
}
function getIsInBuilder(state) {
  return state;
}
function reducer(state = getInitialState(), action) {
  switch (action.type) {
    case ActionTypes.SET_IS_IN_BUILDER:
      return action.payload;
    default:
      return state;
  }
}
export {
  getInitialState,
  getIsInBuilder,
  reducer
};
//# sourceMappingURL=is-in-builder.js.map